export const Paths = {
  home: '/',
  store: '/store',
  details: '/product/:asin',
  cart: '/cart',
  previewCheckout: '/checkout',
  successCheckout: '/checkout/success',
  closeWindow: '/return-to-checkout',
  faq: '/faq',
  terms: '/terms',
  privacyPolicy: '/privacy-policy',
  invalid: '*',
};
